export const passwordMinLength = 8

export const passwordMaxLength = 48
